
    const data = {"name":"src/core/icons/window-maximize","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M4 4h16v16H4V4m2 4v10h12V8H6Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            